import React, { useState, useRef, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const services = [
  "⚡ Electrical Installation & Systems",
  "📹 CCTV & Alarm Installation",
  "☀️ Solar System & Installation",
  "📐 Electrical Designs",
  "🌐 Internet & Network Installation",
  "🔒 Electric Fence Installation",
  "📺 TV Installation",
  "🔧 Electronics Repair"
];

const WhatsAppButton = () => {
  const [showChat, setShowChat] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const phoneNumber = '254796049254';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedService || !name || !phone) return;
    // Remove emoji from service name for WhatsApp message
    const cleanService = selectedService.replace(/[^\w\s]/g, '').trim();
    const msg = encodeURIComponent(
      `Hello Musa Electrical,\n\nMy name is ${name}.\nI'm interested in: ${cleanService}.\nContact me at: ${phone}.\n\nMessage: ${message || 'N/A'}\n\nThank you!`
    );
    window.open(`https://wa.me/${phoneNumber}?text=${msg}`, '_blank');
    setShowChat(false);
    setName('');
    setPhone('');
    setSelectedService('');
    setMessage('');
    setShowDropdown(false);
  };

  return (
    <>
      <button
        className="whatsapp-float"
        onClick={() => setShowChat(!showChat)}
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </button>

      {showChat && (
        <div className="whatsapp-chat">
          <div className="chat-header">
            <div className="chat-avatar"><FaWhatsapp /></div>
            <div className="chat-header-info">
              <h4>Musa Electrical</h4>
              <p>🟢 Online | Quick Enquiry</p>
            </div>
            <button className="chat-close" onClick={() => setShowChat(false)}>✕</button>
          </div>

          <div className="chat-body">
            <form className="chat-form" onSubmit={handleSubmit}>
              <input
                type="text" 
                value={name} 
                onChange={(e) => setName(e.target.value)}
                required 
                placeholder="Your Name *" 
                className="chat-input"
              />
              <input
                type="tel" 
                value={phone} 
                onChange={(e) => setPhone(e.target.value)}
                required 
                placeholder="Phone Number *" 
                className="chat-input"
              />

              <div className="dropdown-container" ref={dropdownRef}>
                <button
                  type="button"
                  className="dropdown-button"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <span>{selectedService || "📋 Select a service *"}</span>
                  <span className="dropdown-arrow">▼</span>
                </button>
                {showDropdown && (
                  <div className="dropdown-list">
                    {services.map((service) => (
                      <div
                        key={service}
                        className={`dropdown-list-item ${selectedService === service ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedService(service);
                          setShowDropdown(false);
                        }}
                      >
                        {service}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Your Message (optional)"
                className="chat-input chat-textarea"
                rows="3"
              />

              <button type="submit" className="chat-submit" disabled={!selectedService || !name || !phone}>
                <FaWhatsapp /> Send via WhatsApp
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
